@let slides = productGallery().imageMaps;

@if (orientationScale() > 3) {
  <app-embla-slider
    [slides]="slides"
    [options]="{ loop: false, dragFree: false, skipSnaps: true, dragThreshold: 10 }"
    [showDots]="false"
    [showArrows]="false"
    [navButtonClasses]="'button button--secondary button-icon button--sm'"
    [showScrollbar]="true"
    (slideInView)="onSliderTranslate()"
    (slideChange)="onSliderTranslate()"
  >
    @for (item of slides; track item.id) {
      @let isLandscape = pointMapOrientations()[$index] === 2;
      <app-media
        [media]="item.media || undefined"
        (mouseenter)="onMediaEnter(pointMap)"
        (mouseleave)="onMouseLeave($event, pointMap)"
        (click)="onMediaClick($event, pointMap)"
        [width]="isLandscape ? 1640 : 800"
        [height]="isLandscape ? 990 : 1000"
        [cssClasses]="'media-point-map-container'"
      >
        <app-media-point-map
          class="media__overlay"
          #pointMap
          [points]="item.items"
          [showMinimalDotsFirst]="false"
          [originalWidth]="item.media?.width ?? null"
          [originalHeight]="item.media?.height ?? null"
          [cropWidth]="isLandscape ? 1640 : 800"
          [cropHeight]="isLandscape ? 990 : 1000"
          [anchor]="item.media?.anchor ?? 'middlecenter'"
        ></app-media-point-map>
      </app-media>
    }
  </app-embla-slider>
} @else {
  <!-- <ul class="gallery-grid row">
    @for (item of slides; track item.id) {
      @let isLandscape = pointMapOrientations()[$index] === 2;
      <li class="gallery-grid__item" [class.is--landscape]="isLandscape">
        <app-media
          [media]="item.media || undefined"
          (mouseenter)="onMediaEnter(pointMap)"
          (mouseleave)="onMouseLeave($event, pointMap)"
          (click)="onMediaClick($event, pointMap)"
          [width]="isLandscape ? 1640 : 800"
          [height]="isLandscape ? 990 : 1000"
          [cssClasses]="'media-point-map-container'"
        >
          <app-media-point-map class="media__overlay" #pointMap [points]="item.items"></app-media-point-map>
        </app-media>
      </li>
    }
  </ul> -->

  <ul class="row product-gallery-list">
    @for (item of slides; track item.id) {
      @let isLandscape = pointMapOrientations()[$index] === 2;
      <li class="col-md-4" [class.col-md-8]="isLandscape">
        <app-media
          [media]="item.media || undefined"
          (mouseenter)="onMediaEnter(pointMap)"
          (mouseleave)="onMouseLeave($event, pointMap)"
          (click)="onMediaClick($event, pointMap)"
          [width]="isLandscape ? 1620 : 800"
          [height]="isLandscape ? 990 : 1000"
          [cssClasses]="'media-point-map-container'"
          [cssContainerClasses]="' d-flex h-100 w-100'"
          class="d-flex h-100 w-100"
        >
          <app-media-point-map
            class="media__overlay"
            #pointMap
            [points]="item.items"
            [showMinimalDotsFirst]="false"
            [originalWidth]="item.media?.width ?? null"
            [originalHeight]="item.media?.height ?? null"
            [cropWidth]="isLandscape ? 1620 : 800"
            [cropHeight]="isLandscape ? 990 : 1000"
            [anchor]="item.media?.anchor ?? 'middlecenter'"
          ></app-media-point-map>
        </app-media>
      </li>
    }
  </ul>
}
